export default __webpack_public_path__ + "static/media/box-with-tag-min.df710b20.svg";